module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "export-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('actions.export.unpaid.title'),
      "size": "small",
      "visible": _vm.orderDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.orderDialogVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.$t('hint.project.export.main')))]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.export.secondary')))]), _vm._v(" "), (_vm.exportsLeft === 0) ? _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.price')
    }
  }, [_vm._v("\n        ￥ 120 / " + _vm._s(_vm.$t('common.project')) + "\n        "), _c('a', {
    staticClass: "price-link",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("升级账户，导出100个项目只需￥1999！")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.payType')
    }
  }, [_c('el-radio-group', {
    staticClass: "payment",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "wechat"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.wechat')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "alipay"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.alipay')))])], 1)], 1)], 1) : _c('div', {
    staticClass: "has-quotas"
  }, [_c('el-checkbox', {
    attrs: {
      "theme": "info",
      "checked": true,
      "disabled": true
    }
  }, [_vm._v("\n        使用账号导出额度（" + _vm._s(_vm.exportsLeft === null ? '不限次数' : ("还剩" + _vm.exportsLeft + "次")) + "）\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.orderDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.placeOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.submit')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('actions.export.paid.title'),
      "size": "small",
      "visible": _vm.exportDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.exportDialogVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "export-content"
  }, [(_vm.state === 'completed') ? _c('div', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.archiveUrl,
      "target": "_blank"
    }
  }, [_vm._v("点击链接下载")]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("\n          请用浏览器直接下载，暂不支持第三方下载工具。遇到问题请加QQ群：461571276，联系我们\n        ")])]) : (_vm.state === 'exceed_error') ? _c('div', [_c('p', [_c('span', {
    staticClass: "danger"
  }, [_vm._v("注意：")]), _vm._v("您的导出额度已使用完毕")]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("您可以新建项目，重新上传PPT源文件，并支付导出费用，来获得最新的导出文件。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("您仍然可以下载之前导出的文件，但该文件"), _c('span', {
    staticClass: "danger"
  }, [_vm._v("可能")]), _vm._v("与现在上传的源文件效果不一致")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "href": ("/projects/" + (_vm.project.id) + "/export?send_file=true"),
      "target": "_blank"
    }
  }, [_vm._v("点击链接下载上次导出的文件")]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("\n          请用浏览器直接下载，暂不支持第三方下载工具。遇到问题请加QQ群：461571276，联系我们\n        ")])]) : _c('div', {
    staticClass: "hint"
  }, [_c('p', [_c('i', {
    staticClass: "ppj-icon-spinner",
    staticStyle: {
      "margin-right": "0.5em"
    }
  }), _vm._v("服务器正在生成导出的zip包，请保持该页面打开，等待打包完成后下载。若长时间转化不成功，请加QQ群：461571276，联系我们\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04cb37e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/setting/infos/export.dialog.vue
// module id = 892
// module chunks = 3